import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";

import classNames from "classnames";
import OrderTableCell from "./OrderTableCell";

const Row = ({
  prepareRow,
  onSelectRow,
  editable,
  row,
  selected,
  rulesByItem,
}) => {
  prepareRow(row);

  return (
    // eslint-disable-next-line react/jsx-key
    <tr
      {...row.getRowProps()}
      className={classNames("order-table-row", {
        unassigned: row.values.group === "-" && !rulesByItem,
        selected: selected
      })}
      onClick={() => {
        onSelectRow(row);
      }}
    >
      {row.cells.map((cell) => (
        <OrderTableCell
          key={`${row.id}-${cell.column.id}`}
          cell={cell}
          editable={editable}
          rowId={row.id}
        />
      ))}
    </tr>
  );
};

Row.propTypes = {
  prepareRow: PropTypes.func,
  onSelectRow: PropTypes.func,
  editable: PropTypes.bool,
  row: PropTypes.object,
  ordersCalculationId: PropTypes.number,
  selected: PropTypes.bool,
  rulesByItem: PropTypes.bool
};

export default React.memo(Row, (prevProps, nextProps) => {
  return (
    prevProps.prepareRow === nextProps.prepareRow &&
    prevProps.ordersCalculationId === nextProps.ordersCalculationId &&
    prevProps.editable === nextProps.editable &&
    prevProps.selected === nextProps.selected &&
    prevProps.onSelectRow === nextProps.onSelectRow &&
    _.isEqual(prevProps.row.values, nextProps.row.values)
  );
});
